// Strings added before Stage 4 (platform rows, unknown models, trending, furniture, dealers page).
export const MORE = {
  en: {
    categories_count: "12 Categories",
    price_check_hint: "Check today's price on Amazon or Flipkart and change it if needed.",
    dym_title: "Did you mean?",
    unk_title: "Not in our list yet — no problem",
    unk_suggested: "Suggested new price from similar {brand} models: {p}. Change it if you know today's price.",
    unk_bands: "Don't know the price? Pick a range:",
    unk_low_note: "Estimate will show Low confidence because this model is not in our list yet.",
    enter_price_required_all: "Please enter today's new price of this item (or pick a price range).",
    price_checked_on: "New price checked on {d}",
    price_crowd: "New price from recent user reports ({d})",
    conf_reason_new_price_crowd: "Today's new price comes from recent reports by users (not yet checked by Valuelix).",
    conf_reason_rough_estimate: "Rough estimate: prices of used furniture and other items vary a lot.",
    rows_title: "Compare buyers",
    rows_sub: "Highest first. Each price is a Valuelix estimate for that type of buyer.",
    filter_all: "All",
    group_exchange: "Exchange (credit on new device)",
    group_store: "Store trade-in",
    payout_sell_yourself: "You sell yourself",
    payout_cash: "Cash / UPI",
    payout_exchange_credit: "Exchange credit only",
    payout_store_credit: "Store credit",
    check_quote: "Check exact quote",
    highest: "Highest",
    dealers_row_title: "Valuelix local dealers",
    dealers_row_sub: "Real offers from verified shops near you — free, your number stays private.",
    dealers_row_btn: "Get offers",
    trending_title: "Most checked this week",
    trending_checks: "{n} checks",
    nav_dealers_page: "For shops",
    poster_download: "Download A4 poster (PDF)",
    hero3d_example: "Example result",
    bd_older_model: "Older model: checked against launch price",
    review_q: "How was your selling experience?",
    review_hint: "Optional. No name or phone is shown. Reviews appear after a quick check by Valuelix.",
    review_placeholder: "A few words (optional) — e.g. was our estimate close?",
    review_send: "Send review", review_skip: "Skip",
    review_pick_stars: "Please choose 1 to 5 stars",
    review_thanks: "Thank you! Your review will appear after a quick check.",
    share_result_text: "My {m} ({c}, bought {y}) is worth about {l} – {h} on Valuelix (estimate). Check yours free: {u}",
    share_friend: "Share with a friend who is selling",
    share_friend_text: "Selling an old phone or laptop? Check its fair price free on Valuelix before you sell — no login: {u}",
    model_page_link: "See {m} resale prices by year and condition",
    footer_resale_prices: "Resale prices by model",
    footer_guides: "Selling guides",
    checking_price: "Checking latest price…",
    search_continue: "Continue",
    choose_model_title: "Which one is yours? Tap it.",
    not_in_list: "My model is not in this list",
    show_all_matches: "See all {n} matches",
    type_more: "Many models fit. Type a bit more of the name, or pick one.",
    finding_model: "Finding this model and today's price…",
    bell_new_offer: "🎉 {n} new offer(s) from nearby shops!",
    bell_see: "See offers",
    card_saved: "Card saved to your phone.",
    dl_forgot: "Forgot password?",
    da_camera: "Camera",
    nd_photos_title: "Add photos of your device (optional)",
    nd_photos_sub: "Shops can give a more exact offer. Up to 3 photos, sent only to the shops you ask.",
    nd_photo_fail: "Request sent, but the photos could not be uploaded.",
    da_gallery: "Gallery",
    dl_send_link: "Email me a reset link",
    dl_reset_sent: "If this email is registered, a reset link has been sent. Check Inbox and Spam.",
    dl_new_password: "Set a new password",
    dl_save_password: "Save new password",
    dl_reset_done: "Password changed.",
    card_link_copied: "Link copied — paste it in WhatsApp under the photo.",
    da_address_opt: "Full address (optional)",
    da_cats_title: "What do you buy?",
    da_more: "More details (optional) — hours, brands, price range",
    dd_new_request: "🔔 {n} new customer request(s) — send your offer!",
    card_cta: "Check your device's price free",
    card_disclaimer: "Estimate, not an offer. Final price after inspection.",
    ai_search_hint: "Model not in the list? Find it with AI",
    finding_model_sub: "Detecting RAM / storage variants and today's new price — a few seconds.",
    ai_found: "Found {m} — today's new price filled in (estimated). Please check it.",
    price_checked_est: "Estimated new price, checked on {d}. Change it if you know today's price.",
    conf_reason_new_price_ai: "Today's new price is an estimate checked automatically (not yet verified by Valuelix).",
    sponsored: "Sponsored", verified: "Verified", ratings_word: "ratings",
    rate_q: "How was this dealer? (after you met or talked)", rate_thanks: "Thanks for rating this dealer.",
    affiliate_note: "Affiliate link — Valuelix may earn a small fee. Your price is not affected.",
    consent_text: "Can we count your visit anonymously? It helps us improve Valuelix. No name, phone or ads — and nothing is counted if you say no.",
    hero3d_breakdown: "Every step shown",
    hero3d_breakdown_sub: "Clear price breakdown",
    hero3d_dealers: "Local dealers",
    hero3d_dealers_sub: "Real offers near you",
  },
  hi: {
    categories_count: "12 श्रेणियाँ",
    price_check_hint: "आज की कीमत Amazon या Flipkart पर देखें और ज़रूरत हो तो बदलें।",
    dym_title: "क्या आपका मतलब यह था?",
    unk_title: "यह मॉडल अभी हमारी लिस्ट में नहीं है — कोई बात नहीं",
    unk_suggested: "मिलते-जुलते {brand} मॉडलों से सुझाई गई नई कीमत: {p}. आज की कीमत पता हो तो बदल दें।",
    unk_bands: "कीमत नहीं पता? एक रेंज चुनें:",
    unk_low_note: "यह मॉडल अभी लिस्ट में नहीं है, इसलिए भरोसा 'कम' दिखेगा।",
    enter_price_required_all: "कृपया इस सामान की आज की नई कीमत लिखें (या कीमत की रेंज चुनें)।",
    price_checked_on: "नई कीमत {d} को जाँची गई",
    price_crowd: "नई कीमत हाल की यूज़र रिपोर्ट से ({d})",
    conf_reason_new_price_crowd: "आज की नई कीमत यूज़र्स की हाल की रिपोर्ट से है (Valuelix ने अभी जाँची नहीं)।",
    conf_reason_rough_estimate: "मोटा अनुमान: पुराने फर्नीचर और दूसरे सामान की कीमत बहुत अलग-अलग होती है।",
    rows_title: "खरीदारों की तुलना",
    rows_sub: "सबसे ज़्यादा कीमत पहले। हर कीमत उस तरह के खरीदार के लिए Valuelix का अनुमान है।",
    filter_all: "सभी",
    group_exchange: "एक्सचेंज (नए फोन पर छूट)",
    group_store: "स्टोर ट्रेड-इन",
    payout_sell_yourself: "खुद बेचें",
    payout_cash: "कैश / UPI",
    payout_exchange_credit: "सिर्फ एक्सचेंज छूट",
    payout_store_credit: "स्टोर क्रेडिट",
    check_quote: "सही कीमत देखें",
    highest: "सबसे ज़्यादा",
    dealers_row_title: "Valuelix के लोकल डीलर",
    dealers_row_sub: "आपके पास की जाँची हुई दुकानों से असली ऑफर — मुफ्त, आपका नंबर निजी रहता है।",
    dealers_row_btn: "ऑफर लें",
    trending_title: "इस हफ्ते सबसे ज़्यादा देखे गए",
    trending_checks: "{n} बार देखा",
    nav_dealers_page: "दुकानदारों के लिए",
    poster_download: "A4 पोस्टर डाउनलोड करें (PDF)",
    hero3d_example: "उदाहरण नतीजा",
    bd_older_model: "पुराना मॉडल: लॉन्च कीमत से भी जाँचा",
    review_q: "बेचने का अनुभव कैसा रहा?",
    review_hint: "वैकल्पिक। कोई नाम या फोन नहीं दिखेगा। Valuelix की जाँच के बाद ही समीक्षा दिखती है।",
    review_placeholder: "कुछ शब्द (वैकल्पिक) — जैसे, क्या हमारा अनुमान सही था?",
    review_send: "समीक्षा भेजें", review_skip: "छोड़ें",
    review_pick_stars: "कृपया 1 से 5 स्टार चुनें",
    review_thanks: "धन्यवाद! जाँच के बाद आपकी समीक्षा दिखेगी।",
    share_result_text: "मेरा {m} ({c}, {y} में खरीदा) Valuelix पर करीब {l} – {h} का है (अनुमान)। अपना मुफ्त देखें: {u}",
    share_friend: "बेचने वाले दोस्त को भेजें",
    share_friend_text: "पुराना फोन या लैपटॉप बेच रहे हो? बेचने से पहले Valuelix पर मुफ्त में सही कीमत देखो — लॉगिन नहीं चाहिए: {u}",
    model_page_link: "{m} की साल और हालत के हिसाब से रीसेल कीमतें देखें",
    footer_resale_prices: "मॉडल के हिसाब से रीसेल कीमतें",
    footer_guides: "बेचने की गाइड",
    checking_price: "ताज़ा कीमत देखी जा रही है…",
    search_continue: "आगे बढ़ें",
    choose_model_title: "आपका कौन-सा है? उस पर टैप करें।",
    not_in_list: "मेरा मॉडल इस लिस्ट में नहीं है",
    show_all_matches: "सभी {n} मॉडल देखें",
    type_more: "कई मॉडल मिलते हैं। नाम थोड़ा और लिखें, या एक चुनें।",
    finding_model: "यह मॉडल और आज की कीमत ढूँढ रहे हैं…",
    bell_new_offer: "🎉 पास की दुकानों से {n} नया ऑफ़र आया!",
    bell_see: "ऑफ़र देखें",
    card_saved: "कार्ड फ़ोन में सेव हो गया।",
    dl_forgot: "पासवर्ड भूल गए?",
    da_camera: "कैमरा",
    nd_photos_title: "अपने डिवाइस की फ़ोटो जोड़ें (वैकल्पिक)",
    nd_photos_sub: "दुकान ज़्यादा सही ऑफ़र दे पाएगी। 3 फ़ोटो तक, सिर्फ़ उन्हीं दुकानों को जाएँगी जिनसे आप ऑफ़र मांगें।",
    nd_photo_fail: "रिक्वेस्ट चली गई, पर फ़ोटो अपलोड नहीं हो पाई।",
    da_gallery: "गैलरी",
    dl_send_link: "रीसेट लिंक ईमेल करें",
    dl_reset_sent: "अगर यह ईमेल रजिस्टर्ड है, तो रीसेट लिंक भेज दिया गया है। Inbox और Spam देखें।",
    dl_new_password: "नया पासवर्ड बनाएँ",
    dl_save_password: "नया पासवर्ड सेव करें",
    dl_reset_done: "पासवर्ड बदल गया।",
    card_link_copied: "लिंक कॉपी हो गया — WhatsApp में फ़ोटो के नीचे पेस्ट करें।",
    da_address_opt: "पूरा पता (वैकल्पिक)",
    da_cats_title: "आप क्या खरीदते हैं?",
    da_more: "और जानकारी (वैकल्पिक) — समय, ब्रांड, दाम सीमा",
    dd_new_request: "🔔 {n} नए ग्राहक की रिक्वेस्ट — अपना ऑफ़र भेजें!",
    card_cta: "अपने डिवाइस का दाम मुफ़्त देखें",
    card_disclaimer: "यह अनुमान है, ऑफ़र नहीं। असली दाम जाँच के बाद तय होगा।",
    ai_search_hint: "मॉडल लिस्ट में नहीं? AI से खोजें",
    finding_model_sub: "RAM / स्टोरेज वेरिएंट और आज की नई कीमत पहचानी जा रही है — बस कुछ सेकंड।",
    ai_found: "{m} मिल गया — आज की नई कीमत भर दी गई है (अनुमानित)। एक बार जाँच लें।",
    price_checked_est: "अनुमानित नई कीमत, {d} को जाँची गई। आज की कीमत पता हो तो बदल दें।",
    conf_reason_new_price_ai: "आज की नई कीमत अपने-आप जाँचा गया अनुमान है (Valuelix ने अभी पक्का नहीं किया)।",
    sponsored: "प्रायोजित", verified: "जाँचा हुआ", ratings_word: "रेटिंग",
    rate_q: "यह डीलर कैसा रहा? (मिलने या बात करने के बाद)", rate_thanks: "डीलर को रेटिंग देने के लिए धन्यवाद।",
    affiliate_note: "एफिलिएट लिंक — Valuelix को छोटी फीस मिल सकती है। आपकी कीमत पर असर नहीं।",
    consent_text: "क्या हम आपकी विज़िट गुमनाम रूप से गिन सकते हैं? इससे Valuelix बेहतर होता है। कोई नाम, फोन या विज्ञापन नहीं — मना करने पर कुछ नहीं गिना जाता।",
    hero3d_breakdown: "हर कदम साफ़",
    hero3d_breakdown_sub: "कीमत का पूरा हिसाब",
    hero3d_dealers: "लोकल डीलर",
    hero3d_dealers_sub: "पास से असली ऑफर",
  },
};

export const MORE_LABELS = {
  categories: { furniture: { en: "Home & Furniture", hi: "घर व फर्नीचर" } },
  specFields: { furniture_type: { en: "What is it?", hi: "यह क्या है?" } },
  specOptions: {
    fur_almirah: { en: "Almirah / Wardrobe", hi: "अलमारी" },
    fur_sofa: { en: "Sofa", hi: "सोफा" },
    fur_bed: { en: "Bed", hi: "बेड / पलंग" },
    fur_table: { en: "Table / Desk", hi: "टेबल / डेस्क" },
    fur_chair: { en: "Chair", hi: "कुर्सी" },
    fur_dining: { en: "Dining set", hi: "डाइनिंग सेट" },
    fur_other: { en: "Other", hi: "अन्य" },
  },
};
